export const FLUX_APP__SET_SESSION = 'FLUX_APP__SET_SESSION';
export const FLUX_APP__CLEAR_SESSION = 'FLUX_APP__CLEAR_SESSION';
